import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { signInPage } from './SignInPage';

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
